export interface Step {
    offset?: number,
    style?: string,
    src?: string
    height?: number;
}
